import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Clearfix,
} from 'react-bootstrap';
import { reopenPayPeriod } from '../actions';

const buttonClickPropTypes = {
  isClicked: PropTypes.bool.isRequired,
  setClicked: PropTypes.func.isRequired,
  clearClicked: PropTypes.func.isRequired,
};

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  reopenPayPeriodAction: PropTypes.func.isRequired,
  ...buttonClickPropTypes,
});


const withButtonState = withStateHandlers(
  (props) => { return { isClicked: false }; },
  {
    setClicked: (state, props) => {
      return () => { return { isClicked: true }; };
    },
    clearClicked: (state, props) => {
      return () => { return { isClicked: false }; };
    },
  },
);


const OpenPayPeriod = (props) => {
  const {
    payPeriod,
    reopenPayPeriodAction,
    isClicked,
    setClicked,
    clearClicked,
  } = props;

  const handleReopenPayPeriod = async (payPeriodId) => {
    try {
      setClicked();
      await reopenPayPeriodAction(payPeriodId);
    } finally {
      clearClicked();
    }
  };

  return (
    <Clearfix>
      <div>
        <p className="pull-left">
          <strong>NOTE: If you need to edit pay period weeks, reopen the pay period.</strong>
        </p>
        <ButtonToolbar className="pull-right">
          <Button
            disabled={isClicked}
            onClick={() => { handleReopenPayPeriod(payPeriod.id); }}
          >
            Open up pay period
          </Button>
        </ButtonToolbar>
      </div>
    </Clearfix>
  );
};


OpenPayPeriod.propTypes = propTypes;

const mapDispatchToProps = {
  reopenPayPeriodAction: reopenPayPeriod,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withButtonState,
);

export default enhance(OpenPayPeriod);
